import {faker}  from "@faker-js/faker";
import { getOrgApp } from "../helpers/get-orgApp";

export const allSubnets = async () => {
  let orgAppDetails = await getOrgApp();
  let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
  let selectedDept = faker.helpers.arrayElement(selectedOrg.depts);
  let selectedDeptApp = faker.helpers.arrayElement(selectedDept.deptApps);
  const subnets = [
    {
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      Domain: "Network",
      ResourceTags: [],
      ModifiedOn: "2019-08-04 11:52:47",
      AccountNumber: "904433914959",
      OrganizationId: selectedOrg.orgId,
      ResourceId: "subnet-1218e52c",
      CreatedOn: "2019-08-04 11:52:47",
      ResourceType: "Subnet",
      ModifiedBy: null,
      DepartmentId: selectedDept.deptId,
      CreatedBy: null,
      Provider: "Aws",
      ResourceName: "default-subnet",
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      Region: "us-east-1",
      VpcId: "vpc-1594696f",
    },
    {
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      Domain: "Network",
      ResourceTags: [],
      ModifiedOn: "2019-08-04 11:52:47",
      AccountNumber: "904433914959",
      OrganizationId: selectedOrg.orgId,
      ResourceId: "subnet-30deb13f",
      CreatedOn: "2019-08-04 11:52:47",
      ResourceType: "Subnet",
      ModifiedBy: null,
      DepartmentId: selectedDept.deptId,
      CreatedBy: null,
      Provider: "Aws",
      ResourceName: "clusterSubnet",
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      Region: "us-east-1",
      VpcId: "vpc-1594696f",
    },
    {
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      Domain: "Network",
      ResourceTags: [],
      ModifiedOn: "2019-08-04 11:52:47",
      AccountNumber: "904433914959",
      OrganizationId: selectedOrg.orgId,
      ResourceId: "subnet-3aae0766",
      CreatedOn: "2019-08-04 11:52:47",
      ResourceType: "Subnet",
      ModifiedBy: null,
      DepartmentId: selectedDept.deptId,
      CreatedBy: null,
      Provider: "Aws",
      ResourceName: "clusterSubnet2",
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      Region: "us-east-1",
      VpcId: "vpc-1594696f",
    },
    {
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      Domain: "Network",
      ResourceTags: [],
      ModifiedOn: "2019-08-04 11:52:47",
      AccountNumber: "904433914959",
      OrganizationId: selectedOrg.orgId,
      ResourceId: "subnet-3e63c810",
      CreatedOn: "2019-08-04 11:52:47",
      ResourceType: "Subnet",
      ModifiedBy: null,
      DepartmentId: selectedDept.deptId,
      CreatedBy: null,
      Provider: "Aws",
      ResourceName: "clusterSubnet3",
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      Region: "us-east-1",
      VpcId: "vpc-1594696f",
    },
    {
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      Domain: "Network",
      ResourceTags: [],
      ModifiedOn: "2019-08-04 11:52:47",
      AccountNumber: "904433914959",
      OrganizationId: selectedOrg.orgId,
      ResourceId: "subnet-77ed4310",
      CreatedOn: "2019-08-04 11:52:47",
      ResourceType: "Subnet",
      ModifiedBy: null,
      DepartmentId: selectedDept.deptId,
      CreatedBy: null,
      Provider: "Aws",
      ResourceName: "clusterSubnet4",
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      Region: "us-east-1",
      VpcId: "vpc-1594696f",
    },
    {
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      Domain: "Network",
      ResourceTags: [],
      ModifiedOn: "2019-08-04 11:52:47",
      AccountNumber: "904433914959",
      OrganizationId: selectedOrg.orgId,
      ResourceId: "subnet-a66418ec",
      CreatedOn: "2019-08-04 11:52:47",
      ResourceType: "Subnet",
      ModifiedBy: null,
      DepartmentId: selectedDept.deptId,
      CreatedBy: null,
      Provider: "Aws",
      ResourceName: "testSubnet",
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      Region: "us-east-1",
      VpcId: "vpc-1594696f",
    },
  ];

  return subnets.map((sn) => {
    sn.ARN = `arn:aws::subnet:${sn.Region}:${faker.random.alphaNumeric(15)}`;
    return sn;
  });
};
